import Common from "./Common";
import GetConstants from './Constants';
var Constants = GetConstants.getConstans();
import ApiRepository from "./ApiRepository";
import store from '@/store'
import commonFuction from "./Common";
import moment from "moment-timezone";
// import router from '../router';
export default {
    shouldUseLoginCallback(callbackUrl = null) {
        var targetUrl = callbackUrl;

        if (Common.isEmpty(targetUrl) && typeof window !== 'undefined') {
            var currentPath = window.location.pathname || '';
            var currentSearch = window.location.search || '';
            var currentHash = window.location.hash || '';
            targetUrl = `${currentPath}${currentSearch}${currentHash}`;
        }

        return !Common.isEmpty(targetUrl) && targetUrl.includes('/admin/giay-phep-sra');
    },
    buildLoginUrl(callbackUrl = null) {
        var loginUrl = '/auth/login';
        var finalCallbackUrl = callbackUrl;

        if (Common.isEmpty(finalCallbackUrl) && typeof window !== 'undefined') {
            var currentPath = window.location.pathname || '';
            var currentSearch = window.location.search || '';
            var currentHash = window.location.hash || '';
            var currentUrl = `${currentPath}${currentSearch}${currentHash}`;
            if (!Common.isEmpty(currentUrl) && currentPath !== '/auth/login') {
                finalCallbackUrl = currentUrl;
            }
        }

        if (!Common.isEmpty(finalCallbackUrl) && this.shouldUseLoginCallback(finalCallbackUrl)) {
            loginUrl += '?callback_url=' + encodeURIComponent(finalCallbackUrl);
        }

        return loginUrl;
    },
    redirectToLogin(callbackUrl = null) {
        window.location.href = this.buildLoginUrl(callbackUrl);
    },
    async setStateLogin(dataSave) {
        var dataState = {
            uid:(!Common.isEmpty(dataSave.uid)) ? dataSave.uid:'',
            token:(!Common.isEmpty(dataSave.token)) ? dataSave.token:'',
            token_refesh:(!Common.isEmpty(dataSave.token_refesh)) ? dataSave.token_refesh:'',
            dateChangeToken:(moment().tz("UTC").format('YYYYMMDDHHmmss')).toString(),
            list_id_company:(!Common.isEmpty(dataSave.list_id_company)) ? dataSave.list_id_company:[],
            list_department: dataSave?.list_department ?? [],
            role:(!Common.isEmpty(dataSave.role)) ? dataSave.role:null,
            type: (!Common.isEmpty(dataSave.type)) ? dataSave.type:null,
            company_id: (!Common.isEmpty(dataSave.company_id)) ? dataSave.company_id: null,
            fullname: (!Common.isEmpty(dataSave.fullname)) ? dataSave.fullname: null,
            img_company: (!Common.isEmpty(dataSave.img_company)) ? dataSave.img_company: null,
            name_company: (!Common.isEmpty(dataSave.name_company)) ? dataSave.name_company: null,
            company_type: (!Common.isEmpty(dataSave.company_type)) ? dataSave.company_type: null,
        }
        localStorage.setItem('state_login', JSON.stringify(dataState));
    },
    setinfoNormal(dataSave) {
        var dataState = {
            company_id: (!Common.isEmpty(dataSave.company_id)) ? dataSave.company_id: null,
            img_company: (!Common.isEmpty(dataSave.img_company)) ? dataSave.img_company: null,
            name_company: (!Common.isEmpty(dataSave.name_company)) ? dataSave.name_company: null,
            company_type: (!Common.isEmpty(dataSave.company_type)) ? dataSave.company_type: null,
        }
        localStorage.setItem('info_company_normal', JSON.stringify(dataState));
    },
    getinfoNormal() {
        return (localStorage.getItem('info_company_normal')) ? JSON.parse(localStorage.getItem('info_company_normal')) : null;
    },
    async getStateLogin() {
        return (localStorage.getItem('state_login')) ? JSON.parse(localStorage.getItem('state_login')) : null;
    },
    getStateLoginNew() {
        return (localStorage.getItem('state_login')) ? JSON.parse(localStorage.getItem('state_login')) : null;
    },
    async getToken() {
        return (await this.getStateLogin()) ? ((await this.getStateLogin()).token):null;
    },
    getListCompany() {
        var state_login = ( this.getStateLoginNew()) ? (( this.getStateLoginNew())):null;
        var list_id_company = []
        if (state_login){
            var role = state_login.role;
            if (role == 'supper_admin'){
                //bằng null tức ko cần check cty mà lấy all
                list_id_company = null;
            }else {
                list_id_company = (state_login.list_id_company) ? state_login.list_id_company:[]
            }
        }
        return list_id_company;
    },
    async getUid() {
        return (await this.getStateLogin()) ? ((await this.getStateLogin()).uid):null;
    },
    async refeshToken() {
        var state_login =await this.getStateLogin();
        if (!commonFuction.isEmpty(state_login)){
            // console.log("state_loginstate_login:",state_login)
            //Nếu tồn tại login thì check điều kiện refesh token
            //Lấy thời gian hiện tại trừ đi 10 phút
            var minus_time = moment().tz("UTC").subtract(60*10, 'seconds').format('YYYYMMDDHHmmss'); //-10phut //60*10
            var dateChangeToken = state_login.dateChangeToken;
            // console.log("dateChangeToken:",dateChangeToken);
            // console.log("minus_time:",minus_time);
            var token_refesh = state_login.token_refesh;
            if (parseFloat(minus_time) > parseFloat(dateChangeToken)){
                var dataRequest = {
                    token_refesh:token_refesh,
                    minus_time:minus_time,//log date
                    dateChangeToken:dateChangeToken,//log date
                }
                //Gọi API refeshtoken
                ApiRepository.post(Constants.API.REFESH_TOKEN,dataRequest).then(async (response) => {
                    var dataSuccess = response.data;
                    var dataUser = dataSuccess.data;
                    console.log("dataUserdataUserdataUser:",dataUser)
                    store.commit('setUser', dataUser.id)
                    store.commit('setDepartment', dataUser?.list_department ?? [])
                    store.commit('setListCompany', dataUser?.list_id_company ?? [])
                    store.commit('setCompany', dataUser?.company_id ?? null)
                    store.commit('setStatus', 'success')
                    store.commit('setError', null)
                    store.commit('setToken', dataUser.token);
                    store.commit('setType', dataUser.type)
                    store.commit('setTokenRefesh', dataUser.token_refesh);
                    console.log("dataUser.roledataUser.role", dataUser.role);
                    store.commit('setRole', dataUser.role);
                    store.commit('setFullname', dataUser.fullname);
                    store.commit('setRoleCompany', dataUser.role_company);
                    store.commit('setTypeCompany', dataUser.type_company);   
                    store.commit('setCompanyType', dataUser.company_type);
                    var dataState = dataUser;
                    dataState["uid"] = dataUser.id
                    /*dataState["uid"] = dataUser.id
                    dataState["uid"] = dataUser.id
                    var dataState = {
                        uid:dataUser.id,
                        token:dataUser.token,
                        token_refesh:dataUser.token_refesh,
                    }*/
                    await this.setStateLogin(dataState);
                })
                    .catch((error) => {
                        console.log("errorerror:",error)
                        //logout
                        this.clearDataLogout();
                        /*store.commit('setStatus', 'failure')
                        store.commit('setError', error.message)*/
                        //
                    })
            }
        }
    },
    async checkToken(token) {
        const headers = {
            "Authorization": "Bearer "+token,
        };
       var dataRes = false
      await  ApiRepository.post(Constants.API.CHECK_TOKEN_ADMIN, {}, {headers}).then(async (res) => {
          var dataSuccess = res.data;
          var dataUser = dataSuccess.data;
          dataRes= dataUser;
        })
        .catch(error => {
            console.log(error);
            //this.errorMessage = error.message;
            /*var message = error.response.data.message;
            dataRes.status = 2;
            dataRes.message = message;*/
            //API này nếu gặp lỗi thì logout
            this.clearDataLogout();
        });
       return dataRes;
    },
    async clearDataLogout() {
        store.commit('setUser', null)
        store.commit('setFullname', null)
        store.commit('setStatus', 'success')
        store.commit('setError', null)
        store.commit('setToken', null)
        store.commit('setIsLoggedIn', false)
        store.commit('setRole', null)
        store.commit('setType', null)
        store.commit('setDepartment', [])
        store.commit('setListCompany', [])
        store.commit('setCompany', null)
        store.commit('setRoleCompany', null);
        store.commit('setTypeCompany', null); 
        store.commit('setCompanyType', null);
        //localStorage.removeItem("state_login");
        console.log("store?.getters", store?.getters);
        this.getStateLogin().then(async state_login => {
            if (!commonFuction.isEmpty(state_login)){
                //Nếu tồn tại token thì gọi API clear token server
                var token = state_login.token;
                var token_refesh = state_login.token_refesh;
                const headers = {
                    "Authorization": "Bearer "+token,
                };
                await  ApiRepository.post(Constants.API.LOGOUT_ADMIN, {token_refesh:token_refesh, device_token: store?.getters?.deviceToken}, {headers}).then(() => {
                    console.log("logout thành công");
                })
                .catch(error => {
                        console.log("logout :",error);
                });
            }
        })
        //xóa hết localstrore
        localStorage.clear();
        window.location.href = '/auth/login';
    //    router.push('/auth/login')
    },

}
